import React, { Component } from "react";
import Hero from './../../components/hero';
import { Link } from "react-router-dom";
import { Colors } from './../../utils/variables';
import ScrollFadeIn from './../../components/scrollFadeIn';
import './lodging.scss';

export default class Lodging extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background" style={{ backgroundColor: Colors.primaryDark }}>
        <div className="slant-bottom">
          {/* Temporary: hide Book Lodging — restore buttonText / buttonLink on Hero when booking reopens */}
          <Hero
            title={'Lodging'}
            subtitle={'Mountain Club at Kirkwood'}
            backgroundImage={'/images/landscape.jpg'}
            height={'threequarter'}
            tint={''}
          />
        </div>

        <div className="gutter">
          <div className="medium-max-width-container lip shadow" style={{ color: Colors.white, backgroundColor: Colors.primary, marginTop: '5vh', marginBottom: '10vh' }}>
            <div className="large-padding centered-text">
              <p>{'In order to receive the Peak Pursuits special group rate please call '}<strong>{'(855) 948-0694'}</strong>{'. This is a reservation line dedicated to making reservations for group guests. Guests can call every day from 8am-5pm MT.'}</p>
              <p>{'Please refer to the group code: '}<strong>{'SKWPPB25'}</strong>{' or the group name: '}<strong>{'Peak Pursuits 25'}</strong>{' when making your reservation.'}</p>
              <p className="medium-padding" style={{ marginBottom: 0 }}>
                <strong>{'The nightly set rates for lodging at the Mountain Club at Kirkwood Mountain Resort for Peak Pursuits participants will be:'}</strong><br />
                <strong>{'$149'}</strong>{' for a Queen/Queen'}<br />
                <strong>{'$164'}</strong>{' for a studio'}<br />
                <strong>{'$179'}</strong>{' for a studio plus loft'}<br />
                {'(plus taxes and fees)'}
              </p>
            </div>
          </div>
          <div>
          <ScrollFadeIn>
            <div className="shadow" style={{color:Colors.white, backgroundColor:Colors.primary, backgroundImage:'url(/images/topo-texture.png)'}}>
              <div className="large-padding centered-text">
                <h1>{'Ready to Book A Room?'}</h1>
                <p className="cursive-text subheading">{'Lodging is available for confirmed Free to Roam participants only'}</p>
                <a href="https://www.kirkwood.com/Plan-Your-Trip/stay/details/The-Mountain-Club.aspx?location=50016842" target="_blank" className="lodging-book-link--hidden">
                  <div className="card-button button" style={{color:Colors.white, backgroundColor:Colors.tertiary}}>
                    {'Book Lodging'}
                  </div>
                </a>
              </div>
            </div>
          </ScrollFadeIn>
        </div>

        </div>
      </div>
    );
  }
}
